
export class CrmStrategyBaseClass {
  constructor() {
  }

  getTypeString() {
    console.assert(false, 'not implemented');
  }

  getDefaultLoginUrl() {
    console.assert(false, 'not implemented');
  }

  getNewContactCreationMode(organization) {
    console.assert(false, 'not implemented');
  }


  canMakeIndirectSearch(){
    console.assert(false, 'not implemented');
  }

  canChooseSearchType(){
    console.assert(false, 'not implemented');
  }

  defaultSearchType(){
    console.assert(false, 'not implemented');
  }

}
